import {useItemsDashboard} from '@kit';

import React, {useMemo} from 'react';

import {Layout} from '../../components/layout';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {getApolloError, cls} from '../../components/utils';
import {useRulesQuery} from '../../generated/types';
import {useRoute} from '../../lib/routes';
import {EditHoc} from '../../components/edit-hoc';
import {RuleView} from './view';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

export const RulesPage: React.FC = () => {
	const {data, loading, error} = useRulesQuery({ssr: true});
	const rules = data?.rules || [];
	const titles = useMemo(() => new Map(rules.map((rule) => [rule.id, rule.title])), [rules]);

	const router = useRoute();
	const query = router?.query || {};

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: rules,
		id: query.id as string,
		loading,
		route: 'rule',
		baseRoute: 'rules',
		sidebarHeader: (rule) => rule.title || '',
		sidebarSecondary: (rule) => (rule.parentId && titles.get(rule.parentId)) || rule.originalTitle,
	});

	const title = showView && selected ? selected.title : 'Правила';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="rules" />}
			{notFound && <NotFoundSeo />}
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<RuleView ruleId={selectedId} title={title} />
							) : (
								<EditHoc load={() => import('./edit-buttons').then((m) => m.CreateRule)} editProps={{}}>
									<div className={pageCss.fullSizeBlock}>Выберите правило</div>
								</EditHoc>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
